// import _ from 'lodash';
import App from '@/views/constants/app';

import Employers from '@/resources/constants/employers';

import { SubNavigationTab } from '@/shared/helpers/classes';
import TabHelper from '@/shared/helpers/tabs';

import WorkStock from '@/views/constants/work-stock';

const state = {
  workStockTabs: [
    new SubNavigationTab({
      component: 'WorkStockIndex',
      text: 'Werkvoorraad',
      props: null,
      navigateAction: WorkStock.Actions.Tabs.OPEN,
      isCloseable: false,
      closeAction: null,
      isSingleTon: true,
      isActive: true
    })
  ]
};

const getters = {
  workStockTabs: state => state.workStockTabs
};

const actions = {
  [Employers.Actions.SELECT] ({ commit }) {
    commit(WorkStock.Mutations.CLEAR);
  },

  [WorkStock.Actions.Tabs.CLOSE] ({ commit }, tab) {
    commit(WorkStock.Mutations.Tabs.CLOSE, tab);
  },

  [WorkStock.Actions.Tabs.OPEN] ({ commit }, tab) {
    commit(WorkStock.Mutations.Tabs.OPEN, tab);
  },

  [WorkStock.Actions.Tabs.OPEN_DETAILS] ({ commit }, workStockItem) {
    let tab = state.workStockTabs
      .find(t => t.component === 'WorkStockDetails' && workStockItem.id === t.props.id);

    if (tab == null) {
      tab = new SubNavigationTab({
        component: 'WorkStockDetails',
        text: 'Item #' + workStockItem.id,
        props: { id: workStockItem.id },
        navigateAction: WorkStock.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: WorkStock.Actions.Tabs.CLOSE,
        isSingleton: false,
        isActive: false
      });
    }

    commit(WorkStock.Mutations.Tabs.ADD, tab);
    commit(WorkStock.Mutations.Tabs.OPEN, tab);
  }
};

const mutations = {
  [WorkStock.Mutations.CLEAR] (state) {
    state.workStockTabs = [
      new SubNavigationTab({
        component: 'WorkStockIndex',
        text: 'Werkvoorraad',
        props: null,
        navigateAction: WorkStock.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleTon: true,
        isActive: true
      })
    ];
  },

  [App.Mutations.CLEAR] (state) {
    state.workStockTabs = [
      new SubNavigationTab({
        component: 'WorkStockIndex',
        text: 'Werkvoorraad',
        props: null,
        navigateAction: WorkStock.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleTon: true,
        isActive: true
      })
    ];
  },

  [WorkStock.Mutations.Tabs.ADD] (state, payload) {
    state.workStockTabs = TabHelper.addTab(payload, state.workStockTabs);
  },

  [WorkStock.Mutations.Tabs.CLOSE] (state, payload) {
    if (payload != null) {
      TabHelper.removeTab(payload, state.workStockTabs);
    }
  },

  [WorkStock.Mutations.Tabs.OPEN] (state, payload) {
    state.workStockTabs = TabHelper.activateTab(payload, state.workStockTabs);
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
